import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { warehousePageData, warehouseFAQs } from "./warehousedata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForWareHouseManagement() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Warehouse Management Software — AI-Powered Warehouse Operations"
        description="EkkBaz AI Warehouse Management cuts labour time per order by 50%, achieves 99.9% picking accuracy, and delivers real-time inventory control — transforming your warehouse into a precision competitive advantage."
        keywords="warehouse management software, WMS AI, warehouse picking optimization, inventory management system, multi-warehouse management, automated warehouse"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/warehouse`}
        productName="Warehouse Management"
        faqItems={warehouseFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Warehouse Management"
        subtitle="AI-optimised picking, real-time inventory tracking, and automated replenishment — cutting warehouse labour by 50% and achieving 99.9% accuracy."
        from="warehouse"
      />
      <EnhancedPageLayout {...warehousePageData} />
      <UpdateFooter />
    </div>
  );
}
